import React, {useEffect, useState} from 'react'
import {cx} from '@linaria/core'

import {getBrandHeaderLogoUrl} from '@daedalus/core/src/_web/brand/utils'
import {RouterAgnosticLink as Link} from '@daedalus/core/src/_web/router/components/RouterAgnosticLink'
import {Brand} from '@daedalus/core/src/brand/types'
import urls from '@daedalus/core/src/utils/url'

import {logoStyles} from './styles'

interface Props {
  brand: Brand
  logoUrl?: string
  children: React.ReactNode
}

export const SearchTopBarLogoWrapper: React.FC<Props> = ({
  brand,
  logoUrl,
  children
}) => {
  const [brandLogoUrl, setBrandLogoUrl] = useState(logoUrl)

  useEffect(() => {
    // some partners want a custom logo url, so we check for that first
    setBrandLogoUrl(getBrandHeaderLogoUrl(brand, logoUrl))
  }, [brand, logoUrl])

  if (brandLogoUrl) {
    return (
      <a data-id="BrandLogo" className={cx(logoStyles)} href={brandLogoUrl}>
        {children}
      </a>
    )
  }

  return (
    <Link data-id="BrandLogo" className={cx(logoStyles)} to={urls.root}>
      {children}
    </Link>
  )
}
